export interface IContentLanguages {
  code: string;
  language: string;
  nativeScript: string;
}

const EN: IContentLanguages = {
  code: 'EN',
  language: 'English',
  nativeScript: 'English',
};
const ZH_CN: IContentLanguages = {
  code: 'ZH-CN',
  language: 'Simplified Chinese',
  nativeScript: '汉语',
};
const ZH_TW: IContentLanguages = {
  code: 'ZH-TW',
  language: 'Traditional Chinese',
  nativeScript: '漢語',
};
const HI: IContentLanguages = {
  code: 'HI',
  language: 'Hindi',
  nativeScript: 'हिन्दी',
};
const ES: IContentLanguages = {
  code: 'ES',
  language: 'Spanish',
  nativeScript: 'Español',
};
const AR: IContentLanguages = {
  code: 'AR',
  language: 'Arabic',
  nativeScript: 'العربية',
};
const FR: IContentLanguages = {
  code: 'FR',
  language: 'French',
  nativeScript: 'Français',
};
const MS: IContentLanguages = {
  code: 'MS',
  language: 'Malay',
  nativeScript: 'Bahasa Melayu',
};
const PT: IContentLanguages = {
  code: 'PT',
  language: 'Portuguese',
  nativeScript: 'Português',
};
const RU: IContentLanguages = {
  code: 'RU',
  language: 'Russian',
  nativeScript: 'Русский',
};
const UR: IContentLanguages = {
  code: 'UR',
  language: 'Urdu',
  nativeScript: 'اردو',
};
const ID: IContentLanguages = {
  code: 'ID',
  language: 'Indonesian',
  nativeScript: 'Bahasa Indonesia',
};
const DE: IContentLanguages = {
  code: 'DE',
  language: 'German',
  nativeScript: 'Deutsch',
};
const JA: IContentLanguages = {
  code: 'JA',
  language: 'Japanese',
  nativeScript: '日本語',
};
const TR: IContentLanguages = {
  code: 'TR',
  language: 'Turkish',
  nativeScript: 'Türkçe',
};
const VI: IContentLanguages = {
  code: 'VI',
  language: 'Vietnamese',
  nativeScript: 'Tiếng Việt',
};
const KO: IContentLanguages = {
  code: 'KO',
  language: 'Korean',
  nativeScript: '한국어',
};
const TH: IContentLanguages = {
  code: 'TH',
  language: 'Thai',
  nativeScript: 'ไทย',
};
const IT: IContentLanguages = {
  code: 'IT',
  language: 'Italian',
  nativeScript: 'Italiano',
};
const PL: IContentLanguages = {
  code: 'PL',
  language: 'Polish',
  nativeScript: 'Polski',
};
const RO: IContentLanguages = {
  code: 'RO',
  language: 'Romanian',
  nativeScript: 'Română',
};
const NL: IContentLanguages = {
  code: 'NL',
  language: 'Dutch',
  nativeScript: 'Nederlands',
};
const HU: IContentLanguages = {
  code: 'HU',
  language: 'Hungarian',
  nativeScript: 'Magyar',
};
// const SR: IContentLanguages = {
//   code: 'SR',
//   language: 'Serbian',
//   nativeScript: 'Српски / Srpski',
// };
const EL: IContentLanguages = {
  code: 'EL',
  language: 'Greek',
  nativeScript: 'Ελληνικά',
};
const SV: IContentLanguages = {
  code: 'SV',
  language: 'Swedish',
  nativeScript: 'Svenska',
};
const CS: IContentLanguages = {
  code: 'CS',
  language: 'Czech',
  nativeScript: 'Čeština',
};
const BG: IContentLanguages = {
  code: 'BG',
  language: 'Bulgarian',
  nativeScript: 'български',
};
const HE: IContentLanguages = {
  code: 'HE',
  language: 'Hebrew',
  nativeScript: 'עברית',
};
const SK: IContentLanguages = {
  code: 'SK',
  language: 'Slovak',
  nativeScript: 'Slovenčina',
};
const DA: IContentLanguages = {
  code: 'DA',
  language: 'Danish',
  nativeScript: 'Dansk',
};
const FI: IContentLanguages = {
  code: 'FI',
  language: 'Finnish',
  nativeScript: 'Suomi',
};
const HR: IContentLanguages = {
  code: 'HR',
  language: 'Croatian',
  nativeScript: 'Hrvatski',
};
const NO: IContentLanguages = {
  code: 'NO',
  language: 'Norwegian',
  nativeScript: 'Norsk',
};
const LT: IContentLanguages = {
  code: 'LT',
  language: 'Lithuanian',
  nativeScript: 'Lietuvių',
};
const LV: IContentLanguages = {
  code: 'LV',
  language: 'Latvian',
  nativeScript: 'Latviešu',
};
const ET: IContentLanguages = {
  code: 'ET',
  language: 'Estonian',
  nativeScript: 'Eesti',
};
const FA: IContentLanguages = {
  code: 'FA',
  language: 'Persian',
  nativeScript: 'فارسی',
};
// { code: 'BN', language: 'Bengali', nativeScript: '' },
// { code: 'PA', language: 'Punjabi', nativeScript: '' },
// { code: 'JV', language: 'Javanese', nativeScript: '' },
// { code: 'TA', language: 'Tamil', nativeScript: '' },
// { code: 'FA', language: 'Persian', nativeScript: '' },
// { code: 'HA', language: 'Hausa', nativeScript: '' },
// { code: 'TL', language: 'Tagalog', nativeScript: '' },
// { code: 'AZ', language: 'Azerbaijani', nativeScript: '' },
// { code: 'CEB', language: 'Cebuano', nativeScript: '' },
// { code: 'SH', language: 'Serbo-Croatian', nativeScript: '' },

export const contentLanguages: IContentLanguages[] = [
  EN,
  ZH_CN,
  ZH_TW,
  HI,
  ES,
  AR,
  FR,
  MS,
  PT,
  RU,
  UR,
  ID,
  DE,
  JA,
  TR,
  VI,
  KO,
  TH,
  IT,
  PL,
  RO,
  NL,
  HU,
  EL,
  SV,
  CS,
  BG,
  HE,
  SK,
  DA,
  FI,
  HR,
  NO,
  LT,
  LV,
  ET,
  FA,
].sort((a, b) => {
  if (a.language < b.language) return -1;
  if (a.language > b.language) return 1;
  return 0;
});
